<template>
  <v-card>
      <v-card-title class="headline">{{$t('delete')}}?</v-card-title>
    <v-card-text>{{$t('doyouwanttodelete')}}</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="dialogueClose">{{$t('no')}}</v-btn>
      <v-btn color="green darken-1" text @click="deleteData">{{$t('yes')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  name: "deleteModal",
  props: ["deleteFormData"],
  /*watch: {
    created: {
      handler: function(val) {
        console.log({val});
      },
      deep: true
    }
  },*/
  data() {
    return {
      created: false,
      servicesData:{
        data:{},
        message:"",
        color:""
      }
    };
  },
  methods: {
    dialogueClose() {
      this.servicesData.message = 'Cancelled'
      this.servicesData.color = 'red'
      this.$emit("formResponse", this.servicesData);
    },
    deleteData() {
      axios
        .post(this.deleteFormData.url, {})
        .then((response) => {
          this.servicesData.data=response.data
          this.servicesData.message="Data Deleted Succcessfully"
          this.servicesData.color="success"
          this.dialogueClose()
        })
        .catch(response => {
          this.servicesData.data=response.data
          this.servicesData.message="Could not delete Please Contact Admin"
          this.servicesData.color="error"
          this.dialogueClose()

        });
    }
  }
};
</script>

<style scoped>
</style>